import { Component, OnInit } from '@angular/core';

declare const $: any;

@Component({
  selector: 'app-root',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $.material.init();
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/account/account.component.ts